import { useMediaQuery } from 'react-responsive';
import { breakpoints } from '@zep-us/zus/tokens';

/**
 * @deprecated 디자인시스템 breakpoint가 적용된 useViewPort를 사용해 주세요.
 */
export const useViewportDeviceInternal = () => {
  const isLaptop = useMediaQuery({
    query: `(min-width: ${breakpoints.tabletLg + 1}px) and (max-width: ${
      breakpoints.laptopLg
    }px)`,
  });

  const isTablet = useMediaQuery({
    query: `(min-width: ${breakpoints.mobileLg + 1}px) and (max-width: ${
      breakpoints.tabletLg
    }px)`,
  });

  const isMobile = useMediaQuery({
    query: `(min-width: ${breakpoints.mobileSm + 1}px) and (max-width: ${
      breakpoints.tabletLg
    }px)`,
  });

  const isMobileSmall = useMediaQuery({
    query: `(max-width: ${breakpoints.mobileSm}px)`,
  });

  return {
    isLaptop,
    isTablet,
    isMobile,
    isMobileSmall,
  };
};
